export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10617.371ec166.jpg";